export const share = {
  share: {
    shape:
      '<path fill="#000000" d="M6.625 19c-.467 0-.854-.154-1.162-.462-.309-.309-.463-.696-.463-1.163V15h1v2.375c0 .167.063.312.188.437s.27.188.437.188h10.75a.597.597 0 0 0 .437-.188.597.597 0 0 0 .188-.437V15h1v2.375c0 .467-.154.854-.462 1.163-.309.308-.696.462-1.163.462H6.625Zm4.875-3.775v-8.65L9.175 8.9l-.725-.7L12 4.65l3.55 3.55-.725.7L12.5 6.575v8.65h-1Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
